import { Injectable } from '@angular/core';
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {MapPosition} from "../../models/MapPosition";

@Injectable({
  providedIn: 'root'
})
export class MyPositionService {

  public isActive = false;
  public latestCoords = null;
  public entity = null;
  public isFollowing = false;
  public placeObjectsInCurrentPosition = false;

  constructor(private view: CesiumAdapterService) {
    this.isActive = window['MY_POSITION'];
  }

  canPlaceObject() {
    return (this.isActive && this.latestCoords);
  }

  reCenter() {
    if (this.latestCoords) {
      let height = this.view.viewer.camera.positionCartographic.height;
      let p = new MapPosition({latitude: this.latestCoords.latitude, longitude: this.latestCoords.longitude, height: height});
      this.view.setupCamera(p);
    }
  }

  toggleFollowing() {
    this.isFollowing = !this.isFollowing;
    if (this.isFollowing) {
      this.reCenter();
    }
  }

  togglePlaceInCurrentPosition() {
    this.placeObjectsInCurrentPosition = !this.placeObjectsInCurrentPosition;
  }

  initialize() {
    if (this.isActive) {
      navigator.geolocation.watchPosition((v) => {
        this.latestCoords = v.coords;
        if (!this.entity) {
          this.entity = this.view.viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(v.coords.longitude, v.coords.latitude),
            name: 'Current Position',
            billboard: {
              image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAFYElEQVR4nO2b20/bVhzHz0lPbBVysw0ZSS16IU1zAVSJBxrRCwjEVCG1Gitb+wdsUrf2edpLlT1Pe+FhD3tau8vDpKkq06qqdOsFKC2jkyAUwqDtUAUTNJeScPMl9h4qZwmQhgTbJ7T7Sl/pJDbi9/n6xPZxfgHgf+FTMBgkgsEggbMGqPU/OHXqmnN83NeyslJWz3HkgVRqVw0AgAEAWjmO3A0AACTJrQIgLwIAoghJUwTBPbVYlkJu98Sdnp7Tc1rXqLqamvr9LPv8C5stPmQ08jwAslyMCYLnaTo6xLKzwePHB724ufIJ+nzhLoaJ/IaQIBYLncsICSLDRG/5fI+7gA4ztyB5PBPnaDr+h9rQuUzT0SGfL/wBbm5w5Migl2VnrxoMki7g2ZZkhon2NjY+qscC73ZPXyBJLqE/eLZJklt0uabO6wbe0dFHORxzPwCA46hvbggl2eGYu9LW1mvVFL69fcBOUbG7uIFzmaLiA01N/U5N4AOBRy6zORHCDZnPVmtitKFhuEZV+ObmoSqzOTGCG26rNpmS44HA/T2qwHd09FEUFR/ADVX4xyHWr8o5wW6f/x43TLFm2effbQve7Z78FMLSOdsXaggluabm6cWi4Bsb//SVwnV+uyZJbjEQGPYUHADDRHpwF6+Wq6r+uVYQvNc7eXYnT/31hlCS/f7wma3yQ5stPoS7aLVN07FhsJVVZH392NlSus1V017v5HvreQ3r35iddXxUastttbSwwHzy2h1aW+/5EBIE3EdKKyMkCE1N/YcymbNmQDjsOieKCGkQfklIFBGamdn/YeZ7WQGsru5+V9+S9Nfy8u6Tm27o6vplD0FwHO5pqrUJguc6O284FO70DAiFDp3geQLrM3o9xPNGYmxs/wnldTqARMKM59kaBi0vm+uUcToAQTCq+xChhMXz/7FmBLDrrQkglUIuZZwOQJZhJZ5y9FcqBSuUcUYABhOecvSXLEOzMjYAAEB3dzcpiqgMX0n6ShSRSflWesNa4K2VxZKI475J0csWy2JU4U7PAAilJTzR6y8I5aQyTgdgMMgLeMrRXxDKL5RxRgCpp3jK0V8IiU+UcToAkhSebL77myejUdgYQHl5chRPOfrLZkuGlHE6gMOHp34nCIHHU5J+Ikme93rH7m660WaLP8R9idLaNB0bzGTOuhEymVZuaBh+Sai8fOV65uusAPbuffYjQqKob0n6CSFRrK7++6fX7sQwkVu4p6lWZpjozfW8G9YCDsf8NwDIKuZeOrLbI19vZT/4Jp4MGSY6CDb5xmez1aDsdM5/BeGbMwsMBlmurFz4EhQytSsqXlzDfdTUst2+8HPOcHJtOHhw5jOS5BOFZV16Iklucd++Z58X9cd+/8QFPG2w6vhVi8z0x9tKsKpq/gpukGJdXT1zOR9f3kditbWjF1+1ye0sUVS8z+9/XFyD1Hq1tj54x2xO7phGSav15Xhz821WFXhFDQ3DNVZrYhQ3XH74xIjqrbKK2tsH7AwTu4MbMpcpKtZ/7Ng9R16Q7aitrdfqcMxdLqUuMggl2emc+/bkyesWTeEz5XJNnSdJbhE3PEmuvXS7/9repa5YBQL3PU7n3FWDQZJwHHWTaelGXd1o4V2gasvvD5+h6ehDfdrrJJmmYw88nolO3NzrBf3+sfcZJtKrRacZQoLAMJGbtbUTnaDU+/iOHu1zs+zsJZqOPiAIbq1YaILg1ygqdp9ln19qaclub1NLmifZ1fVrVSh0sCWZNNVxnPGAKBpdAMiVsmyw8LyxDAAACEJYgVBKAABeICROEwT/zGRaGvF4wrd7ek7Pa10jNpXCj6ffev0L9R+e9Uf3k7oAAAAASUVORK5CYII=',
              scale: .25
            }
          });
        }
        this.entity.position = Cesium.Cartesian3.fromDegrees(v.coords.longitude, v.coords.latitude);
        if (this.isFollowing) {
          this.reCenter();
        }
        this.view.viewer.scene.requestRender();
        console.log('Location', v);
      }, error => { console.error('Location', error); }, {enableHighAccuracy: true, timeout: 10000, maximumAge: 0});
    }
  }
}
